<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>{{ errorMessage }}</div>
        </div>

        <div class="mb-3">
            <label class="form-label">Inkoopnummer</label>
            <input type="text" class="form-control" [class.is-invalid]="formErrors.purchase_number"
                [(ngModel)]="item.purchase_number" placeholder="" />
        </div>

        <div class="mb-3">
            <label class="form-label">Factuur organisatie</label>
            <input type="text" class="form-control" [class.is-invalid]="formErrors.invoice_name"
                [(ngModel)]="item.invoice_name" placeholder="" />
        </div>

        <div class="mb-3">
            <label class="form-label">Factuur e-mail</label>
            <input type="text" class="form-control" [class.is-invalid]="formErrors.invoice_email"
                [(ngModel)]="item.invoice_email" placeholder="" />
        </div>

        <div class="mb-3">
            <label class="form-label">Factuur adres</label>
            <input type="text" class="form-control" [class.is-invalid]="formErrors.invoice_address"
                [(ngModel)]="item.invoice_address" placeholder="" />
        </div>

        <div class="mb-3">
            <label class="form-label">Factuur postcode</label>
            <input type="text" class="form-control" [class.is-invalid]="formErrors.invoice_postal_code"
                [(ngModel)]="item.invoice_postal_code" placeholder="" />
        </div>

        <div class="mb-3">
            <label class="form-label">Factuur plaats</label>
            <input type="text" class="form-control" [class.is-invalid]="formErrors.invoice_city"
                [(ngModel)]="item.invoice_city" placeholder="" />
        </div>

        <div class="mb-3">
            <label class="form-label">Factuur land</label>
            <input type="text" class="form-control" [class.is-invalid]="formErrors.invoice_country"
                [(ngModel)]="item.invoice_country" placeholder="" />
        </div>

        <div class="mb-3">
            <label class="form-label">Verzendkosten</label>
            <input type="number" class="form-control" [(ngModel)]="item.shipping_costs" placeholder="" />
        </div>
        <!-- Submit Button -->
        <div class="form-buttons">
            <button type="button" class="btn btn-primary" *ngIf="item['id']" (click)="save()">
                Opslaan
            </button>
        </div>
    </div>
</div>
